import React from 'react';
import { Drawer } from './Drawer';
import { DrawerToggleState } from '../models/actionStates';

import { useRecoilValue } from 'recoil';
import { cartDrawerState } from '../recoil/selectors';
import CartDrawer from '../cart/CartDrawer';

const DrawerSingletonApp = () => {
  const cartDrawer = useRecoilValue(cartDrawerState);

  return (
    <Drawer
      lockViewport={true}
      isVisible={cartDrawer?.toggleState === DrawerToggleState.Open}
      backgroundColor={cartDrawer?.backgroundColor}
      width={cartDrawer?.width}
      height={cartDrawer?.height}
      minWidth={cartDrawer?.minWidth}
      minHeight={cartDrawer?.minHeight}
      maxWidth={cartDrawer?.maxWidth}
      maxHeight={cartDrawer?.maxHeight}
    >
      {cartDrawer?.contents || <CartDrawer />}
    </Drawer>
  );
};

export default DrawerSingletonApp;
